import type { SxProps, Theme } from '@mui/material'
import { baseSkeletonStyles } from '../utils/skeleton'

export const styles = {
  skeleton: {
    graph: baseSkeletonStyles.graph,
  },
} satisfies Record<string, SxProps<Theme>>
